"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "userBackground", {
  enumerable: true,
  get: function get() {
    return _userBackground["default"];
  }
});
var _userBackground = _interopRequireDefault(require("./userBackground"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }